var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.alive)?_c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('div',{staticClass:"app-bg",class:{
        Tickets: this.$route.name == 'submit a ticket',
        Login: this.$route.name == 'Login',
        Nfind: this.$route.name == 'Nfind',
        Bind: this.$route.name == 'Bind',
        Content: this.$route.name == 'KNOW ISSUES',
    }},[(_vm.header_show)?_c('app-header',{on:{"setLang":_vm.setLang}}):_vm._e(),(_vm.topalert_show)?_c('app-topalert'):_vm._e(),(_vm.isRouterAlive)?_c('router-view',{on:{"header":_vm.header,"footer":_vm.footer}}):_vm._e(),(_vm.footer_show)?_c('app-footer',{attrs:{"lang":_vm.preferredLang},on:{"setLang":_vm.setLang}}):_vm._e()],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }